import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
	FreudButtonModule,
	FreudTooltipModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { VcScheduleAlertComponent } from './vc-schedule-alert.component';

@NgModule({
	declarations: [VcScheduleAlertComponent],
	imports: [
		CommonModule,
		TranslateModule,
		FreudButtonModule,
		FreudTooltipModule,
	],
	exports: [VcScheduleAlertComponent],
	providers: [],
})
export class VCSCheduleAlertModule {}
